/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Mdx, Link } from '@ta-interaktiv/contentbricks'
import { MDXProvider } from '@mdx-js/react'
// import { VaccineStage } from 'components/vaccineStage'
import { CSSTransition } from 'react-transition-group'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'

// TODO Set the correct article ID here
const ARTICLE_ID = '945354485376'
const isMobile = window.innerWidth < 768

// ARN messager
// Vecteur viral
// Proteines recombinantes (spike)
// Virus inactivé

const vaccines = [
  {
    title: <Mdx file={require('text/EreoB6mIixAg.mdx')} />,
    pharma: <Mdx file={require('text/GYiCgmGfixIb.mdx')} />,
    desc: <Mdx file={require('text/iXApEmJqixQJ.mdx')} />,
    tech: <Mdx file={require('text/EkhoB_A3W0b0.mdx')} />,
    illu: 'arn',
    id: 0,
    text: {
      who: <Mdx file={require('text/zJFYFBkIjfY5.mdx')} />,
      where: <Mdx file={require('text/dw-mWLkYjtjd.mdx')} />,
      switzerland: <Mdx file={require('text/Wn2qvFYfjwD_.mdx')} />,
      tech: <Mdx file={require('text/38qP0ghxj9br.mdx')} />,
      how: <Mdx file={require('text/3uhs_6aBkBLg.mdx')} />,
      efficacy: <Mdx file={require('text/JYoBh4nlkGox.mdx')} />,
      pro: <Mdx file={require('text/RjPDIfD5kmSt.mdx')} />,
      con: <Mdx file={require('text/vKPaTz3IkrZw.mdx')} />,
      story: <Mdx file={require('text/vOOd4jCYk8QA.mdx')} />,
      effects: <Mdx file={require('text/HB8MoYBqloRa.mdx')} />
    },
    category: 0
  },
  {
    title: <Mdx file={require('text/-r8jtcLwlnU9.mdx')} />,
    pharma: <Mdx file={require('text/xp6PIO5dftIU.mdx')} />,
    desc: <Mdx file={require('text/2H2ztYzeYrNP.mdx')} />,
    tech: <Mdx file={require('text/jH4u_E-Cfp5e.mdx')} />,
    illu: 'arn',
    id: 1,
    text: {
      who: <Mdx file={require('text/zvfOUnEcY10N.mdx')} />,
      where: <Mdx file={require('text/4qivOGecY_Wm.mdx')} />,
      switzerland: <Mdx file={require('text/VA_GbQisZGTJ.mdx')} />,
      tech: <Mdx file={require('text/b8w69U9kZQT1.mdx')} />,
      how: <Mdx file={require('text/qKaJ34mwZY9R.mdx')} />,
      efficacy: <Mdx file={require('text/-9Rey4CYZfjD.mdx')} />,
      pro: <Mdx file={require('text/9agGsSmVaAII.mdx')} />,
      con: <Mdx file={require('text/_NH7w5CDaISH.mdx')} />,
      story: <Mdx file={require('text/PRmz5XzWaORH.mdx')} />,
      effects: <Mdx file={require('text/Sb32Ei5GsKZn.mdx')} />
    },
    category: 0
  },
  {
    title: <Mdx file={require('text/AFjKITPulwqY.mdx')} />,
    pharma: <Mdx file={require('text/kWYH85F0f41h.mdx')} />,
    desc: <Mdx file={require('text/oPjVOBdTjtt3.mdx')} />,
    tech: <Mdx file={require('text/HsDxo5aYf3RE.mdx')} />,
    illu: 'vecteur',
    id: 2,
    text: {
      who: <Mdx file={require('text/w3espkO0gdqb.mdx')} />,
      where: <Mdx file={require('text/w_SowGi0c2Hw.mdx')} />,
      switzerland: <Mdx file={require('text/f-ES_C6VhN2R.mdx')} />,
      tech: <Mdx file={require('text/LzeTnUMdiBCa.mdx')} />,
      how: <Mdx file={require('text/kpLCEWlSiTEh.mdx')} />,
      efficacy: <Mdx file={require('text/hgaefOLvibk3.mdx')} />,
      pro: <Mdx file={require('text/S1yxQhQGi3Qt.mdx')} />,
      con: <Mdx file={require('text/e6Ih_alXjKGw.mdx')} />,
      story: <Mdx file={require('text/jMEt7FDFjXYf.mdx')} />,
      effects: <Mdx file={require('text/SRi03yMhiju_.mdx')} />
    },
    category: 0
  },
  {
    title: <Mdx file={require('text/zz1pnDjDly83.mdx')} />,
    pharma: <Mdx file={require('text/wbtMAm1QgW32.mdx')} />,
    desc: <Mdx file={require('text/r7Ikx8_N6gvq.mdx')} />,
    tech: <Mdx file={require('text/tYMhJTNwjmDg.mdx')} />,
    illu: 'proteine',
    id: 3,
    text: {
      who: <Mdx file={require('text/LgJicNrG6xd1.mdx')} />,
      where: <Mdx file={require('text/XXDbEfWh69B-.mdx')} />,
      switzerland: <Mdx file={require('text/lk7LZGpQ7OIH.mdx')} />,
      tech: <Mdx file={require('text/pevqZ8eA8BYZ.mdx')} />,
      how: <Mdx file={require('text/IIczNTww8heF.mdx')} />,
      efficacy: <Mdx file={require('text/QQ772TdP8qEP.mdx')} />,
      pro: <Mdx file={require('text/MFYzC5ZA8L4P.mdx')} />,
      con: <Mdx file={require('text/AEkkdX-4ACAM.mdx')} />,
      story: <Mdx file={require('text/G7wtFHt-AaBw.mdx')} />,
      effects: <Mdx file={require('text/zAaf7fQy_e3v.mdx')} />
    },
    category: 1
  },
  {
    title: <Mdx file={require('text/iZXmMVKLl31e.mdx')} />,
    pharma: <Mdx file={require('text/KIi_j9nXgerQ.mdx')} />,
    desc: <Mdx file={require('text/g0We5XGXHk2P.mdx')} />,
    tech: <Mdx file={require('text/6X7GJiZsgiCZ.mdx')} />,
    illu: 'arn',
    id: 4,
    text: {
      who: <Mdx file={require('text/AI-_UxMTHtUK.mdx')} />,
      where: <Mdx file={require('text/HZ-T1i3rHy2h.mdx')} />,
      switzerland: <Mdx file={require('text/qHF0HdX4H6HI.mdx')} />,
      tech: <Mdx file={require('text/vR6BsVqGIVG_.mdx')} />,
      how: <Mdx file={require('text/vhWmcNiaImwy.mdx')} />,
      efficacy: <Mdx file={require('text/--SOG_GAItWh.mdx')} />,
      pro: <Mdx file={require('text/dhRJ4WzQJHEA.mdx')} />,
      con: <Mdx file={require('text/UpC2zp5OJOPq.mdx')} />,
      story: <Mdx file={require('text/Tn9WaM3zJcT-.mdx')} />,
      effects: <Mdx file={require('text/qPu2BUO7I0dA.mdx')} />
    },
    category: 3
  },
  {
    title: <Mdx file={require('text/VB6HTekIl6tS.mdx')} />,
    pharma: <Mdx file={require('text/ssEMj4dhgM0M.mdx')} />,
    desc: <Mdx file={require('text/nsQabTIQJpP3.mdx')} />,
    tech: <Mdx file={require('text/kWSEbIe0gP7L.mdx')} />,
    illu: 'vecteur',
    id: 5,
    text: {
      who: <Mdx file={require('text/XderMICRJxuu.mdx')} />,
      where: <Mdx file={require('text/CmudXvKBJ6EZ.mdx')} />,
      switzerland: <Mdx file={require('text/WImbGyTxKAet.mdx')} />,
      tech: <Mdx file={require('text/R77GT5CFKGo8.mdx')} />,
      how: <Mdx file={require('text/Y6uckBmGKPxU.mdx')} />,
      efficacy: <Mdx file={require('text/B29pnC4rKXgx.mdx')} />,
      pro: <Mdx file={require('text/9c1_B0o1KtCM.mdx')} />,
      con: <Mdx file={require('text/uDu_bMs2Kzbq.mdx')} />,
      story: <Mdx file={require('text/v9rgIJU9K0lj.mdx')} />,
      effects: <Mdx file={require('text/mWYm7VnDKdVX.mdx')} />
    },
    category: 0
  },
  {
    title: <Mdx file={require('text/3fVsMp5Hl9vd.mdx')} />,
    pharma: <Mdx file={require('text/6DTnuN5Mg3Po.mdx')} />,
    desc: <Mdx file={require('text/JhAgP469atUl.mdx')} />,
    tech: <Mdx file={require('text/kghFqgKxg6rw.mdx')} />,
    illu: 'vecteur',
    id: 6,
    text: {
      who: <Mdx file={require('text/WUWVylLoa3ts.mdx')} />,
      where: <Mdx file={require('text/eVOb4Uf1a9Tv.mdx')} />,
      switzerland: <Mdx file={require('text/N9nF4cK-bCFx.mdx')} />,
      tech: <Mdx file={require('text/594H0q7HbHW1.mdx')} />,
      how: <Mdx file={require('text/qEhiXIGBbT55.mdx')} />,
      efficacy: <Mdx file={require('text/7x-ihpyDbaGs.mdx')} />,
      pro: <Mdx file={require('text/FByF6FDxb63K.mdx')} />,
      con: <Mdx file={require('text/kMCpcetEcER0.mdx')} />,
      story: <Mdx file={require('text/eSPyLAhvcLNn.mdx')} />,
      effects: <Mdx file={require('text/3isn0Wq7bysM.mdx')} />
    },
    category: 2
  },
  {
    title: <Mdx file={require('text/4rtSM6JwmAu5.mdx')} />,
    pharma: <Mdx file={require('text/Vb-X0C2nhA36.mdx')} />,
    desc: <Mdx file={require('text/54rNJnlYcQPg.mdx')} />,
    tech: <Mdx file={require('text/fvmXBplThDap.mdx')} />,
    illu: 'inactive',
    id: 7,
    text: {
      who: <Mdx file={require('text/s9CuLnYTcTp2.mdx')} />,
      where: <Mdx file={require('text/6Baea9b8cYDb.mdx')} />,
      switzerland: <Mdx file={require('text/eRkedPHAceOr.mdx')} />,
      tech: <Mdx file={require('text/aFW3BiithN3h.mdx')} />,
      how: <Mdx file={require('text/59LJJjk-cng6.mdx')} />,
      efficacy: <Mdx file={require('text/HXAgtb2ScsFH.mdx')} />,
      pro: <Mdx file={require('text/zI_saYg7c1rv.mdx')} />,
      con: <Mdx file={require('text/M4ZbYfpsdBs5.mdx')} />,
      story: <Mdx file={require('text/xqHz6RChdHsh.mdx')} />,
      effects: <Mdx file={require('text/JeAZ4dEPcxXH.mdx')} />,
      sino: <Mdx file={require('text/y1jFtcGwdM36.mdx')} />
    },
    category: 2
  },
  {
    title: <Mdx file={require('text/0yNWJSUamDYk.mdx')} />,
    pharma: <Mdx file={require('text/JU5kokHmdUnf.mdx')} />,
    desc: <Mdx file={require('text/y2jlG_O_dWqA.mdx')} />,
    illu: 'autre',
    id: 8,
    text: {
      misc: <Mdx file={require('text/UIwV3b72dac_.mdx')} />
    },
    category: 3
  },
  {
    title: <Mdx file={require('text/rqTMh0_kmG9W.mdx')} />,
    pharma: <Mdx file={require('text/0JAVAGZc-K-J.mdx')} />,
    desc: <Mdx file={require('text/eENJm0_rdfdB.mdx')} />,
    illu: 'autre',
    id: 9,
    text: {
      misc: <Mdx file={require('text/okYm6bXddg-I.mdx')} />
    },
    category: 3
  }
]

const flattenStyles = props => {
  return props.children
}

const categoryTitle = props => {
  return <h4 className='ui ta text center aligned header'>{props.children}</h4>
}

const removeItalics = props => {
  return null
}

export function AppComponent() {
  const [showInfoLayer, setShowInfoLayer] = useState(false)
  const [selectedVaccine, setSelectedVaccine] = useState(null)

  const handleCardClick = data => {
    console.log(data)
    document.body.classList.add('freeze')
    setSelectedVaccine(data)
    setShowInfoLayer(true)
  }

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <Mdx file={require('text/bGwCb67YRyKp.mdx')} />
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              <b>
                <Mdx file={require('text/8lstlCRjcMCa.mdx')} />
              </b>
            </div>
            <div className='ta updated'>
              <Mdx file={require('text/Z8_ogXK1hWHt.mdx')} />
            </div>
          </div>
          <div className='ta text'>
            <MDXProvider components={{ a: Link }}>
              <Mdx file={require('text/n96cAa_zD5hc.mdx')} />
            </MDXProvider>
          </div>
        </div>
      </div>

      {/* <VaccineStage /> */}

      <div className='ui vertical segment light-green'>
        <div className='ui center aligned container'>
          <div className='category-number'>1</div>
          <MDXProvider components={{ h2: categoryTitle }}>
            <Mdx file={require('text/NqPy5TWPiqa1.mdx')} />
          </MDXProvider>
          <hr />
          <div className='ui link cards'>
            {vaccines
              .filter(v => v.category === 0)
              .map((v, i) => (
                <VaccineCard
                  data={v}
                  handleClick={handleCardClick}
                  key={`vaccine-${v.id}`}
                  {...v}
                />
              ))}
          </div>
        </div>
      </div>

      <div className='ui vertical segment light-orange'>
        <div className='ui center aligned container'>
          <div className='category-number'>2</div>
          <MDXProvider components={{ h2: categoryTitle }}>
            <Mdx file={require('text/ZdJnrGccmNEO.mdx')} />
          </MDXProvider>
          <hr />
          <div className='ui link cards'>
            {vaccines
              .filter(v => v.category === 1)
              .map((v, i) => (
                <VaccineCard
                  data={v}
                  handleClick={handleCardClick}
                  key={`vaccine-${v.id}`}
                  {...v}
                />
              ))}
          </div>
        </div>
      </div>

      <div className='ui vertical segment light-purple'>
        <div className='ui center aligned container'>
          <div className='category-number'>3</div>
          <MDXProvider components={{ h2: categoryTitle }}>
            <Mdx file={require('text/lJg2zI12mSK6.mdx')} />
          </MDXProvider>
          <hr />
          <div className='ui link cards'>
            {vaccines
              .filter(v => v.category === 2)
              .map((v, i) => (
                <VaccineCard
                  data={v}
                  handleClick={handleCardClick}
                  key={`vaccine-${v.id}`}
                  {...v}
                />
              ))}
          </div>
        </div>
      </div>

      <div className='ui vertical segment light-red'>
        <div className='ui center aligned container'>
          <div className='category-number'>4</div>
          <MDXProvider components={{ h2: categoryTitle }}>
            <Mdx file={require('text/7qyDZdOymYLU.mdx')} />
          </MDXProvider>
          <hr />
          <div className='ui link cards'>
            {vaccines
              .filter(v => v.category === 3)
              .map((v, i) => (
                <VaccineCard
                  data={v}
                  handleClick={handleCardClick}
                  key={`vaccine-${v.id}`}
                  {...v}
                />
              ))}
          </div>
        </div>
      </div>

      <CSSTransition
        unmountOnExit
        in={showInfoLayer}
        timeout={200}
        classNames='dimmer-container'
      >
        <div
          className='dimmer'
          onClick={() => {
            setShowInfoLayer(false)
            document.body.classList.remove('freeze')
          }}
        />
      </CSSTransition>

      <CSSTransition
        unmountOnExit
        in={showInfoLayer}
        timeout={400}
        classNames='info-close-container'
      >
        {selectedVaccine && (
          <div
            className={`info-layer-close vaccine-${selectedVaccine.category}`}
            onClick={() => {
              setShowInfoLayer(false)
              document.body.classList.remove('freeze')
            }}
          >
            <div className='close' />
          </div>
        )}
      </CSSTransition>

      <CSSTransition
        unmountOnExit
        in={showInfoLayer}
        timeout={200}
        classNames='info-layer-container'
      >
        {selectedVaccine && (
          <div className={`info-layer vaccine-${selectedVaccine.id}`}>
            <div
              className='info-header'
              onClick={() => {
                setShowInfoLayer(false)
                document.body.classList.remove('freeze')
              }}
            >
              <div className='image'>
                <img
                  src={require(`../../images/illustration-${selectedVaccine.illu}-2.svg`)}
                />
              </div>
              {selectedVaccine.title}
              {selectedVaccine.tech && (
                <div className='header-tech'>
                  Vaccin à{' '}
                  <div style={{ display: 'inline-block' }}>
                    <MDXProvider components={{ p: flattenStyles }}>
                      {selectedVaccine.tech}
                    </MDXProvider>
                  </div>
                </div>
              )}
            </div>
            {selectedVaccine.text.misc && (
              <div className='ui ta text container'>
                <MDXProvider components={{ em: removeItalics, a: Link }}>
                  {selectedVaccine.text.misc}
                </MDXProvider>
              </div>
            )}
            <div className='ui ta text container'>
              <MDXProvider components={{ em: removeItalics, a: Link }}>
                {selectedVaccine.text.who}
              </MDXProvider>
            </div>
            <div className='ui vertical segment'>
              <VaccineDetailBlock
                title='Où est-il utilisé?'
                mdx={selectedVaccine.text.where}
              />
              <VaccineDetailBlock
                title='Qu’en est-il en Suisse?'
                mdx={selectedVaccine.text.switzerland}
              />
              <VaccineDetailBlock
                title='Quelle est la technique utilisée?'
                mdx={selectedVaccine.text.tech}
              />
              <VaccineDetailBlock
                title='Comment est-il administré?'
                mdx={selectedVaccine.text.how}
              />
              <VaccineDetailBlock
                title='Quelle est son efficacité?'
                mdx={selectedVaccine.text.efficacy}
              />
              <VaccineDetailBlock
                title='Quels sont ses points forts?'
                mdx={selectedVaccine.text.pro}
              />
              <VaccineDetailBlock
                title='Quels sont ses points faibles?'
                mdx={selectedVaccine.text.con}
              />
              <VaccineDetailBlock
                title='La petite histoire'
                mdx={selectedVaccine.text.story}
              />
              <VaccineDetailBlock
                title='Quels sont ses effets secondaires?'
                mdx={selectedVaccine.text.effects}
              />
              <VaccineDetailBlock
                title='Des petits frères'
                mdx={selectedVaccine.text.sino}
              />
            </div>
          </div>
        )}
      </CSSTransition>

      <div className='ui vertical grey segment'>
        <div className='ui container'>
          <h4 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            Plus d'articles sur le sujet
          </h4>
          <ArticleTeasers
            numberOfCards='three'
            articleIds={['30473063', '206058854298']}
          />
        </div>
      </div>

      <Footer
        mailTo='caroline.zuercher@tamedia.ch'
        hidePortfolioTeaser
        locale='fr'
        articleId={ARTICLE_ID}
        credits={[
          ['Textes et recherches', 'Caroline Zuercher'],
          ['Conception et réalisation', 'Mathieu Rudaz']
        ]}
      />
    </div>
  )
}

interface VaccineCardProps {
  data: {};
  handleClick: () => void;
}

const VaccineCard = ({ data, handleClick }: VaccineCardProps) => {
  return (
    <MDXProvider components={{ h3: flattenStyles, p: flattenStyles }}>
      <div
        className={`card vaccine-${data.id}`}
        onClick={() => {
          handleClick(data)
        }}
      >
        <div className='image'>
          <img src={require(`../../images/illustration-${data.illu}.svg`)} />
        </div>
        <div className='content'>
          <div className='header'>{data.title}</div>
          <div className='meta'>
            <a>{data.pharma}</a>
          </div>
          <div className='description'>{data.desc}</div>
        </div>
        <div className='extra content'>
          <i className='file alternate icon' /> Lire la fiche
        </div>
        {/* data.tech && (
          <div className='extra content'>
            <i className='dna icon' />{' '}
            <div style={{ display: 'inline-block' }}>{data.tech}</div>
          </div>
        ) */}
      </div>
    </MDXProvider>
  )
}

interface VaccineDetailBlockProps {
  mdx: string;
  title: string;
}

const VaccineDetailBlock = ({ title, mdx }: VaccineDetailBlockProps) => {
  const [showText, setShowText] = useState(false)

  return (
    <>
      {mdx && (
        <div className='vaccine-detail-block'>
          <div className='ui text container ta'>
            <div
              className='vaccine-block-title'
              onClick={() => {
                setShowText(!showText)
              }}
            >
              {title}{' '}
              <i className={`ui icon angle ${showText ? 'up' : 'down'}`} />
            </div>
            <CSSTransition
              unmountOnExit
              in={showText}
              timeout={200}
              classNames='vaccine-block-text-container'
            >
              <div className='vaccine-block-text'>
                <MDXProvider components={{ em: removeItalics, a: Link }}>
                  {mdx}
                </MDXProvider>
              </div>
            </CSSTransition>
          </div>
        </div>
      )}
    </>
  )
}
